import foldersService from "@/services/FoldersService";
import { chain } from "lodash";

const folder = {
  state: {
    draggingFolderId: null,
    activeFolder: {
      activity_logs: [],
      attached_folders: {
        folders: [],
        status: ""
      },
      comments: [],
      confidential: false,
      created_at: "",
      current_owner: {},
      documents: [],
      entity: null,
      folder_status: {},
      folder_type: {},
      id: "",
      interesteds_citizens: [],
      interesteds_users: [],
      last_modification_at: "",
      number: "",
      ownership_requested: false,
      process_number: "",
      subject: "",
      transactions: [],
      user: {}
    },
    activeFolderFilterType: {},
    folders: {},
    foldersFound: [],
    foldersCount: {
      archived: 0,
      inbox: 0,
      sent: 0,
      unreceived: 0,
      revisions: 0,
      signatures: 0
    },
    activeTotalFolders: 0,
    folderTypes: {},
    folderViewMode: "list",
    foldersPagesCount: 0,
    folderIdCounter: 0,
    callCounter: 0
  },
  getters: {
    activeFolder(state) {
      return state.activeFolder;
    },
    activeFolderFilterType(state) {
      return state.activeFolderFilterType;
    },
    folders(state) {
      return state.folders;
    },
    foldersFound(state) {
      return state.foldersFound;
    },
    foldersCount(state) {
      return state.foldersCount;
    },
    folderViewMode(state) {
      return state.folderViewMode;
    },
    folderTypes(state) {
      return state.folderTypes;
    },
    foldersPagesCount(state) {
      return state.foldersPagesCount;
    },
    activeTotalFolders(state) {
      return state.activeTotalFolders;
    },
    draggingFolderId(state) {
      return state.draggingFolderId;
    },
    folderIdCounter(state) {
      return state.folderIdCounter;
    },
    callCounter(state) {
      return state.callCounter;
    }
  },
  mutations: {
    incrementCallCounter(state) {
      state.callCounter++;
    },
    setFolderIdCounter(state, folderId) {
      state.folderIdCounter = folderId;
    },
    setDraggingFolder(state, folderId) {
      state.draggingFolderId = folderId;
    },
    clearDragDrop(state) {
      state.draggingFolderId = null;
    },
    setFolders(state, payload) {
      state.folders = payload;
    },
    setFoldersFound(state, payload) {
      state.foldersFound = [...payload];
    },
    setFolderTypes(state, payload) {
      state.folderTypes = [...payload];
    },
    setActiveFolder(state, payload) {
      state.activeFolder = { ...payload };
    },
    setActiveFolderFilterType(state, payload) {
      state.activeFolderFilterType = { ...payload };
      state.foldersFound = state.folders.filter(
        item => item.folder_type.id === payload.id
      );
    },
    setFolderNumber(state, payload) {
      state.activeFolder = { ...state.activeFolder, number: payload };
    },
    setFolderSubject(state, payload) {
      state.activeFolder = { ...state.activeFolder, subject: payload };
    },
    setFoldersCount(state, payload) {
      state.foldersCount = payload;
    },
    setActiveTotalFolders(state, payload) {
      state.activeTotalFolders = payload;
    },
    setFolderViewMode(state, payload) {
      state.folderViewMode = payload;
    },
    EMPTY_FOLDERS(state) {
      state.folders = [];
      state.foldersFound = [];
      state.activeFolder = {};
      state.foldersCount = {};
    },
    setFoldersPageCount(state, payload) {
      state.foldersPagesCount = payload;
    },
    setInteresteds(state, payload) {
      state.activeFolder.interesteds_users = payload.interesteds_users;
      state.activeFolder.interesteds_citizens = payload.interesteds_citizens;
    }
  },
  actions: {
    async getFoldersArchived({ commit }, payload = { page: 1, limit: 5 }) {
      const { page, limit, searchText } = payload;
      const response = await foldersService.getFoldersArchived(
        page,
        limit,
        searchText
      );
      const archived = chain(response.data.archived)
        .map(item => ({
          ...item,
          ...item.folder,
          created_at: item.created_at,
          folder_section: "archived"
        }))
        .value();
      commit("setFoldersPageCount", response.data.total_pages);
      commit("setActiveTotalFolders", response.data.total);
      commit("setFolders", archived);
    },
    async getFoldersInbox(
      { commit },
      payload = { page: 1, limit: 5, order: "asc", sort: "limit_date" }
    ) {
      const { page, limit, order, sort, searchText, folderTypeId } = payload;
      const response = await foldersService.getFoldersInbox(
        page,
        limit,
        order,
        sort,
        searchText,
        folderTypeId
      );
      const inbox = chain(response.data.inbox)
        .map(item => ({
          ...item,
          ...item.folder,
          created_at: item.created_at,
          folder_section: "inbox"
        }))
        .value();
      commit("setFoldersPageCount", response.data.total_pages);
      commit("setActiveTotalFolders", response.data.total);
      commit("setFolders", inbox);
    },
    async getFoldersUnreceived(
      { commit },
      payload = { page: 1, limit: 5, order: "asc", sort: "limit_date" }
    ) {
      const { page, limit, order, sort, searchText, folderTypeId } = payload;
      const response = await foldersService.getFoldersUnreceived(
        page,
        limit,
        order,
        sort,
        searchText,
        folderTypeId
      );
      const inbox = chain(response.data.unreceived)
        .map(item => ({
          ...item,
          ...item.folder,
          created_at: item.created_at,
          folder_section: "inbox"
        }))
        .value();
      commit("setFoldersPageCount", response.data.total_pages);
      commit("setActiveTotalFolders", response.data.total);
      commit("setFolders", inbox);
    },
    async getCustomFolders(
      { commit },
      payload = {
        id: null,
        page: 1,
        limit: 5,
        order: "asc",
        sort: "limit_date"
      }
    ) {
      const {
        id,
        page,
        limit,
        order,
        sort,
        searchText,
        folderTypeId
      } = payload;
      const response = await foldersService.getFoldersCustom(
        id,
        page,
        limit,
        order,
        sort,
        searchText,
        folderTypeId
      );
      const inbox = chain(response.data.folders)
        .map(item => ({
          ...item,
          ...item.folder,
          created_at: item.created_at,
          folder_section: "inbox"
        }))
        .value();
      commit("setFoldersPageCount", response.data.total_pages);
      commit("setActiveTotalFolders", response.data.total);
      commit("setFolders", inbox);
    },
    async getFoldersSearch({ commit }, payload = { page: 1, limit: 5 }) {
      const { page, limit, searchText } = payload;
      const response = await foldersService.getFoldersSearch(
        page,
        limit,
        searchText
      );
      const search = chain(response.data.folders)
        .map(item => ({
          ...item,
          ...item.folder,
          created_at: item.created_at,
          folder_section: "search"
        }))
        .value();
      commit("setFoldersPageCount", response.data.total_pages);
      commit("setActiveTotalFolders", response.data.total);
      commit("setFolders", search);
    },
    async getFoldersSent({ commit }, payload = { page: 1, limit: 5 }) {
      const { page, limit, searchText } = payload;
      const response = await foldersService.getFoldersSent(
        page,
        limit,
        searchText
      );
      commit("setFoldersPageCount", response.data.total_pages);
      commit("setActiveTotalFolders", response.data.total);
      commit("setFolders", response.data.sent);
    },
    async getFoldersPending({ commit }) {
      const foldersToSignResponse = await foldersService.getFoldersToSign();
      const foldersToSign = foldersToSignResponse.data.pendencies.map(item => {
        const docs = item.documents.filter(
          d => d.has_pending_signatures === true
        );

        return {
          ...item,
          folder_section: "pending",
          pending_type: "signature",
          pending_date: docs[0].signature_date ? docs[0].signature_date : null
        };
      });
      const foldersToReviewResponse = await foldersService.getFoldersToReview();
      const foldersToReview = foldersToReviewResponse.data.pendencies.map(
        item => ({
          ...item,
          folder_section: "pending",
          pending_type: "review",
          pending_date: item.last_transaction.created_at
        })
      );
      commit("setFolders", [...foldersToSign, ...foldersToReview]);
    },
    async getFoldersCount({ commit }) {
      const response = await foldersService.getFoldersCount();
      commit("setFoldersCount", response.data);
    },
    setFolderTypes({ commit }, payload) {
      commit("setFolderTypes", payload);
    },
    setFolders({ commit }, payload) {
      commit("setFolders", payload);
    },
    setFoldersFound({ commit }, payload) {
      commit("setFoldersFound", payload);
    },
    async getActiveFolder({ commit }, payload) {
      return new Promise((resolve, reject) => {
        foldersService
          .getFolder(payload.id)
          .then(response => {
            commit("toggleLoader", { loading: false });
            commit("setActiveFolder", response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    addNumber({ commit }, payload) {
      foldersService
        .addNumber(payload)
        .then(response => {
          commit("setFolderNumber", payload.folder.number);
          commit("toggleSnackbar", {
            show: true,
            timeout: 6000,
            color: "success",
            message: response.data.message,
            messageIcon: "mdi-check"
          });
        })
        .catch(error => {
          commit("toggleSnackbar", {
            show: true,
            timeout: 6000,
            color: "error",
            message: error.message,
            messageIcon: "mdi-alert-outline"
          });
        });
    },
    updateSubject({ commit }, payload) {
      foldersService
        .updateSubject(payload)
        .then(response => {
          commit("setFolderSubject", payload.folder.subject);
          commit("toggleSnackbar", {
            show: true,
            timeout: 6000,
            color: "success",
            message: response.data.message,
            messageIcon: "mdi-check"
          });
        })
        .catch(error => {
          commit("toggleSnackbar", {
            show: true,
            timeout: 6000,
            color: "error",
            message: error.message,
            messageIcon: "mdi-alert-outline"
          });
        });
    },
    FOLDER_VIEW_MODE({ commit }, payload) {
      commit("setFolderViewMode", payload);
    },
    cleanFoldersData({ commit }) {
      commit("EMPTY_FOLDERS");
    },
    setActiveFolderFilterType({ commit }, payload) {
      commit("setActiveFolderFilterType", payload);
    },
    async updateInteresteds({ commit }, payload) {
      const response = await foldersService.getInteresteds(payload.folderId);
      commit("setInteresteds", response.data);
    }
  }
};

export default folder;



// WEBPACK FOOTER //
// ./src/vuex/folder/folders.js